(function() {
    'use strict';

    angular.module('GorillaBoy.shareModal')
    .constant('gbTimepickerConfig', {
        hourStep: 1,
        minuteStep: 15,
        showMeridian: true,
        meridians: ['AM', 'PM'],
        readonlyInput: false,
        mousewheel: true,
        defaultHour: 17 // Constant for 5:00 pm
    })
    .config(['$routeProvider', 'SourceConstant', function($routeProvider, SourceConstant){
        var TEMPLATE_LAYOUT = './share-modal/share_link_modal_dialog.html';

        function resolveParameters() {
            return {
                isFolder: ['$route' , function($route) {
                    return $route.current.params.isFolder;
                }],
                pendingShareType: ['$route' , function($route) {
                    return $route.current.params.shareType;
                }],
                shareResourceId: ['$route' , function($route) {
                    return $route.current.params.resourceId;
                }],
                shareResourceName: ['$route' , function($route) {
                    return $route.current.params.resourceName;
                }],
                isAnonymous: ['$route' , function($route) {
                    return $route.current.params.isAnonymous;
                }],
                currentOwnerOrganizationId: ['$route' , function($route) {
                    return $route.current.params.orgId;
                }],
                currentOwnerUsername: ['$route' , function($route) {
                    return $route.current.params.uname;
                }],
                $uibModalInstance: function() {
                    return null;
                }
            };
        }

        $routeProvider.when('/resources/:resourceId/sharelink', {
            templateUrl : TEMPLATE_LAYOUT,
            controller : 'gbShareLinkModalCtrl',
            auth : true,
            resolve : resolveParameters()
        });
    }]);
}());




